import QueryString from "qs";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { getClass } from "../../api/campusClasses.api";
import { getTimetables } from "../../api/campusClasses3.api";
import ErrorResponse from "../../components/ErrorResponse";
import Loader from "../../components/Loader";
import Attendance from "../../components/tutor/class/Attendance";
import Counseling from "../../components/tutor/class/Counseling";
import CreateCounseling from "../../components/tutor/class/CreateCounseling";
import Level from "../../components/tutor/class/Level";
import ReadCounseling from "../../components/tutor/class/ReadCounseling";
import Test from "../../components/tutor/class/Test";
import TutorHeader from "../../components/tutor/Header";
import useAxios from "../../hooks/useAxios";
import { IGetClass } from "../../models/campusClasses.model";
import { IGetTimetables } from "../../models/campusClasses3.model";
import ClassNotice2 from "../../components/class/class/Notice2";
import Record2 from "../../components/tutor/class/Record2";
import Management from "../../components/tutor/class/Management";

const Block = styled.div`
  padding-top: 10px;

  h1 {
    color: #515151;
    font-size: 30px;
    font-weight: 700;
  }
`;

export enum ClassContents {
  Management,
  Attendance,
  Record,
  Notice,
  Counseling,
  CreateCounseling,
  ReadCounseling,
  Test,
  Level,
}

const TutorClass = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const classCode = String(query.classCode);
  const { data: res, isLoading, error, execute } = useAxios<IGetClass>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetTimetables>();

  const [content, setContent] = useState<ClassContents>(ClassContents.Management);
  const [counselCode, setCounselCode] = useState<number>();

  useEffect(() => {
    if (classCode) {
      execute(getClass(classCode));
      execute2(getTimetables(classCode));
    }
  }, [location]);

  const renderContent = () => {
    switch (content) {
      // 관리 탭
      case ClassContents.Management:
        return (
          <Management
            classData={res?.data}
          />
        );
      // 출결 탭
      case ClassContents.Attendance:
        return (
          <Attendance
            classData={res?.data}
            timetables={res2?.data}
          />
        );
      // 성적 탭
      case ClassContents.Record:
        return (
          <Record2
            classData={res?.data}
            timetables={res2?.data}
          />
        );
      // 알림장 탭
      case ClassContents.Notice:
        return (
          <ClassNotice2
            classCode={classCode}
            className={res?.data?.className}
            isTutor
          />
        );
      // 상담 탭
      case ClassContents.Counseling:
        return (
          <Counseling
            classData={res?.data}
            setContent={setContent}
            setCounselCode={setCounselCode}
          />
        );
      case ClassContents.CreateCounseling:
        return (
          <CreateCounseling
            classData={res?.data}
            setContent={setContent}
          />
        );
      case ClassContents.ReadCounseling:
        return (
          <ReadCounseling
            counselCode={counselCode}
            setContent={setContent}
          />
        );
      // Test 탭
      case ClassContents.Test:
        return (
          <Test />
        );
      // Test 탭
      case ClassContents.Level:
        return (
          <Level
            classData={res?.data}          
          />
        );
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading || isLoading2 ? <Loader /> : null}
      
      <TutorHeader title={res?.data?.className} />

      <div>
        <div className="comm-tab__line">
          <ul>
            <li className={content === ClassContents.Management
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Management)}
              >
                {t('관리')}
              </a>
            </li>
            <li className={content === ClassContents.Attendance
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Attendance)}
              >
                {t('class.tutor.tab1')}
              </a>
            </li>
            <li className={content === ClassContents.Record
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Record)}
              >
                {t('class.tutor.tab2')}
              </a>
            </li>
            <li className={content === ClassContents.Notice
                    ? ' active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Notice)}
              >
                {t('class.tutor.tab3')}
              </a>
            </li>
            <li className={content === ClassContents.Counseling ||
                  content === ClassContents.CreateCounseling ||
                  content === ClassContents.ReadCounseling
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Counseling)}
              >
                {t('class.tutor.tab4')}
              </a>
            </li>
            <li className={content === ClassContents.Test
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Test)}
              >
                {t('class.tutor.tab5')}
              </a>
            </li>
            <li className={content === ClassContents.Level
                    ? 'active'
                    : ''}>
              <a
                className="btn-item"
                onClick={() => setContent(ClassContents.Level)}
              >
                {t('class.tutor.tab6')}
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content" id="custom-tabs-tabContent">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default TutorClass;
